export const uninstall = () => {
  unregister();
  deleteCache();
};

export const unregister = async () => {
  if (window.navigator && navigator.serviceWorker) {
    return navigator.serviceWorker.getRegistrations().then((registrations) => {
      return Promise.all(registrations.map((registration) => registration.unregister()));
    });
  }

  return Promise.resolve();
};

export const deleteCache = async () => {
  return caches.keys().then((keyList) => {
    return Promise.all(keyList.map((key) => caches.delete(key)));
  });
};
